const EnterpriseWechat = () => import('@/views/main/wechatMgmt/enterpriseWechat/EnterpriseWechat.vue')
export default {
  path: '/main/wechatMgmt/enterpriseWechat',
  name: 'enterpriseWechat',
  component: EnterpriseWechat,
}
